import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import lozad from 'lozad';
import Splide from '@splidejs/splide';

const observer = lozad(); // Lazy loads elements with default selector as '.lozad'
observer.observe();


const optsScroll = {
  animateScroll: {
    betweenPages: false,
    samePageWithHash: true,
    samePage: true,
  }
};

const optsScripts = {
  optin: true
};

const options = {
  plugins: [
    new SwupScrollPlugin(optsScroll),
    new SwupScriptsPlugin({
      optin: true
    }),
    new SwupHeadPlugin(),
  ]
};
const swup = new Swup(options);

// Events
swup.hooks.on('content:replace', init);

// Start Apline after swup so it works correctly
Alpine.plugin(collapse)
Alpine.plugin(intersect)

window.Alpine = Alpine
Alpine.start();


// // google maps styles
// import {mapstyles} from './mapstyles.js';

// // swiper.js
// import Swiper,  { Autoplay } from 'swiper';
// Swiper.use([Autoplay]);

// datepicker
// import datepicker from 'js-datepicker';


// let start, end, tabledate;
// let roomloaded = false;
// let tableloaded = false;

// function loadDatePicker() {

//   if (roomloaded == false) {
//     l('loadDatePicker - rooms');
//     roomloaded = true;

//     // show picker for homepage / stay / dine / dome / etc 
//     let today = new Date();

//     // start = datepicker('.room-start', {
//     //   id: 1,
//     //   dateFormat: 'mm-dd-yy',
//     //   showAllDates: true,
//     //   minDate: today,
//     //   disableMobile: true,
//     //   onSelect: (instance, date) => {
//     //     // l('calc num of days');
//     //     // end.getRange();
//     //   },
//     //   onShow: (date) => {
//     //     // l(date);
//     //   },
//     //   formatter: (input, date, instance) => {
//     //     const value = date.toLocaleDateString()
//     //     input.value = value // => '1/1/2099'
//     //   }
//     // });

//     // end = datepicker('.room-end', {
//     //   id: 1,
//     //   showAllDates: true,
//     //   minDate: today,
//     //   disableMobile: true,
//     //   formatter: (input, date, instance) => {
//     //     const value = date.toLocaleDateString()
//     //     input.value = value // => '1/1/2099'
//     //   }
//     // });
//   }

//   if (tableloaded == false) {
//     l('loadDatePicker - tables');
//     tableloaded = true;
//     // show picker for homepage / stay / dine / dome / etc
//     let today = new Date();

//     // tabledate = datepicker('.table-date', {
//     //   id: 2,
//     //   showAllDates: true,
//     //   disableMobile: true,
//     //   minDate: today,
//     //   formatter: (input, date, instance) => {
//     //     const value = date.toLocaleDateString()
//     //     input.value = value // => '1/1/2099'
//     //   }
//     // });
//   }
// }


// Variables 
// const $d = $(document),
//       $w = $(window),
//       $b = $('body');

// const swup = new Swup({
//   // plugins: [new SwupBodyClassPlugin()]
// }); 

// Events
// swup.on('contentReplaced', function () {
//   init();
//   addSlugClassToBody();
//   console.log('updating body class');
//   toggleEventFields();
// });

// $d
//   .on('click', '.booking_a', switchBookTab)
//   .on('click', '.booking_close', closeBooking)  
//   .on('click', '.booking.close', openBooking)  
//   .on('click', '.booking_enquire', openBookingService)
//   .on('click', 'a[href^="#"]:not(.booking_close):not(.accordion_a)', handleAnchor)
//   // .on('click', '.cookie_btn', setCookie)
//   .on('click', '.accordion_a', toggleAccordion)
//   // .on('keypress', toggleSpacer)
//   .on('mouseenter', '.subnav_dropdown', showDropdown)
//   .on('mouseleave', '.subnav_dropdown', hideDropdown)
// .on('mouseenter', '.rollover_a', showRolloverImage)
// .on('mouseleave', '.rollover_a', hideRolloverImage)
// .on('mousemove', '.rollover_a', placeRolloverImage);

// $w.on('scroll', function(e){
//   // if($('.hero').length){
//     if($w.scrollTop() > $w.innerHeight()/2) {
//       $b.addClass('scrolled');
//     } else {
//       $b.removeClass('scrolled');
//     }
//   // }
// });

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
});


function init() {
  l('👍');
  // highlightActive();
  lazyImages();
  // loadSwipers();
  loadSplides();
  // handleAnchor();
  // contactMap();
  // loadDatePicker();
  // setBookingTab();
  // setHeaderBackgroundColor();
  // addSlugClassToBody();
  // ctaCycle();
  // hidePopSuccessMessage();
  // initMap();
}

//

function loadSplides() {

  var elms = document.getElementsByClassName('splide');

  if (elms.length != 0) {
    for (var i = 0; i < elms.length; i++) {
      if (elms[i].parentNode.classList.contains('many')) {
        console.log('many')
        new Splide(elms[i], {
          type: 'loop',
          padding: '0rem',
          pagination: false,
          gap: '1rem',
          perPage: 3,
          autoWidth: true,
          focus: 0,
          omitEnd: true,
          autoplay: true,
          interval: 4000,
          speed: 800, // Adjust transition speed if needed
          drag: 'free', // Enables free movement
          arrows: false, // Hide arrows if needed
        }).mount();
      } else if (elms[i].parentNode.classList.contains('banner_gallery')) {
        console.log('gallery')
        new Splide(elms[i], {
          autoplay: true,
          interval: 5000,
          speed: 800,
          type: 'loop',
          padding: '0rem',
          pagination: false
        }).mount();

      } else {
        console.log('single')
        new Splide(elms[i], {
          autoplay: true,
          interval: 4500,
          speed: 800,
          type: 'loop',
          padding: '0rem',
          pagination: true
        }).on('pagination:mounted', function (data) {
          console.log('pagination mounted');
          console.log(data.items);
          data.list.classList.add('splide__pagination--custom');
          data.items.forEach(function (item) {
            item.button.textContent = String(item.page + 1);
          });
        }).mount();

      }
    }
  }
}


// Functions 
function l(m) {
  console.log(m);
}

// function openBooking() {  
//   l('openBooking');
// }


// let intervals = [];

// function ctaCycle() {
//   // Clear any existing intervals
//   intervals.forEach(interval => clearInterval(interval));
//   intervals = [];

//   $('.cta_image').each(function () {
//     let $e = $(this);
//     let delay = $(this).parent().data('delay');

//     if ($e.find('img').length > 1) {
//       let interval = setInterval(function () {
//         let $active = $e.find('.active');
//         l($active);
//         let $next = ($active.next().length > 0) ? $active.next() : $e.find('img:first');

//         $active.removeClass('active'); //reset the z-index and unhide the image
//         $next.addClass('active'); //make the next image the top one
//       }, delay);

//       // Store the interval ID so we can clear it later
//       intervals.push(interval);
//     }
//   });
// }



// function cycleImages(){
//   l('cycleImages');

//   // $next.css('z-index',2); //move the next image up the pile
//   // $active.fadeOut(600,function(){ //fade out the top image

//   // });
// }

// function ctaImageCyclers() {


//   setInterval(l('hello'), 3000);

// }

// function openBookingService(event) {

//   event.preventDefault();

//   let bookingType = $(this).closest('.booking_view').attr('class').split('booking_view booking_')[1];

//   if (bookingType == 'table') {

//     let url = $(this).attr('href'),
//       $date = $('.table-date').val(),
//       $time = $('.table-time').val(),
//       $party = $('.table-party').val();

//     // validations
//     if ($date.length == 0) { alert('Please pick a date'); return false; }
//     if ($time == null) { alert('Please pick a time'); return false; }
//     if ($party == null) { alert('Please select party size'); return false; }

//     let $time24hr = (parseInt($time.split(':')[0], 10) + 12) + ':' + $time.split(':')[1];
//     let datetime = 'datetime=' + $date.split('/').reverse().join('-') + 'T' + $time24hr;
//     let party = 'partysize=' + $('.table-party').val();
//     let newUrl = url.replace('datetime=0', datetime).replace('partysize=0', party);
//     l('opentable for ' + $party + ' people on ' + $date + ' @ ' + $time);
//     window.open(newUrl, '_blank');

//   }

//   if (bookingType == 'room') {

//     let url = $(this).attr('href'),
//       $checkin = $('.room-start').val(),
//       $checkout = $('.room-end').val(),
//       $guests = $('.room-guests').val();

//     l('checkin: ' + $checkin.split('/').reverse().join('-'));
//     function convertDate(str) {
//       let year = str.split('/').pop();
//       let s = str.split('/').reverse();
//       s.splice(0, 1);
//       return s.join('/') + '/' + year;

//     }

//     let $in = convertDate($checkin);
//     let $out = convertDate($checkout);

//     l($in);
//     l($out);

//     // validations
//     if ($checkin.length == 0) { alert('Please pick a check in date'); return false; }
//     if ($checkout.length == 0) { alert('Please pick a check out date'); return false; }
//     if ($guests == null) { alert('How many people?'); return false; }

//     function treatAsUTC(date) {

//       var result = new Date(date);

//       result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
//       return result;
//     }

//     function daysBetween(startDate, endDate) {
//       var millisecondsPerDay = 24 * 60 * 60 * 1000;
//       return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
//     }
//     let checkin = 'checkin=' + $checkin.split('/').reverse().join('-');
//     let nights = 'nights=' + daysBetween($in, $out);
//     let guests = 'partya=' + $guests;

//     let newUrl = url.replace('nights=0', nights).replace('checkin=0', checkin).replace('partya=0', guests);
//     l(newUrl)
//     l('avvio check in on ' + $checkin + ' for ' + daysBetween($in, $out) + ' nights for ' + $guests + ' guests');
//     window.open(newUrl, '_blank');

//   }






// }

// function closeBooking() {
//   document.querySelector('.booking').classList.add('close');
// }

// function openBooking() {
//   document.querySelector('.booking').classList.remove('close');
// }

// function switchBookTab(e) {
//   e.preventDefault();

//   let id = $(this).parent().attr('id');
//   $('.booking').removeClass().addClass('booking').addClass('booking-' + id);


// }

// function showDropdown(e) {
//   document.querySelector(this).classList.add('open');
// }

// function hideDropdown(e) {
//   $(this).closest('.subnav_li').removeClass('open');
// }

// function placeRolloverImage(e) {
//   l(e.pageX + ' ' + e.pageY);
//   let index = $(this).parent().index();
//   let $img = $('.rollover_' + index);
//   let imgLeft = e.pageX - ($img.width() / 2);
//   l($(this).closest('.rollover').offset().top);
//   let imgTop = e.pageY - $(this).closest('.rollover').offset().top - ($img.height() / 2);
//   $img.css({
//     'left': imgLeft,
//     'top': imgTop
//   });
// }

// function showRolloverImage() {
//   let index = $(this).parent().index(),
//     img = '<img class="rollover_img rollover_' + index + '" src="' + $(this).data('image') + '"/>',
//     $img = $(img);

//   $(this).closest('.rollover').append($img);


//   setTimeout(function () {
//     $img.addClass('in');
//   }, 50);
// }

// function hideRolloverImage() {

//   let $img = $('.rollover_' + $(this).parent().index());

//   $img.removeClass('in');
//   setTimeout(function () {
//     $img.remove();
//   }, 300);



// }

// function toggleAccordion(event) {
//   event.preventDefault();
//   let $parent = $(this).parent();
//   let $content = $(this).next();
//   let contentH = $content.find('.accordion_inner').height() + 50;
//   // l(height);
//   if ($parent.hasClass('active')) {
//     $parent.removeClass('active');
//     $content.css({
//       'height': 0
//     });
//   } else {
//     $parent.addClass('active');
//     $content.css({
//       'height': contentH
//     });
//   }
//   // l($(this).next().addClass('active'))
// }

// function toggleSpacer(event) {
//   if ($('body').hasClass('admin') || $('body').hasClass('noadmin')) {
//     if (event.which == 115) {

//       if ($('body').hasClass('admin')) {
//         $('body').removeClass('admin').addClass('noadmin');
//       } else {
//         $('body').removeClass('noadmin').addClass('admin');
//       }
//     }
//   }
// }

// function contactMap() {
//   l(window.location.pathname);
//   if (window.location.pathname == '/contact') {
//     let lat = parseFloat($('.banner_googlemap').data('latlong').split(', ')[0]).toFixed(3);
//     let long = parseFloat($('.banner_googlemap').data('latlong').split(', ')[1]).toFixed(3);
//     initMap(lat, long);
//   }
// }




// let shouldShowBooking = true; // Global flag to control booking visibility

// function setBookingTab() {
//   let page = window.location.pathname;
//   let id;

//   if (page === '/dine' || page === '/gastrobar') {
//     id = 'table';
//     $('.booking').removeClass().addClass('booking').addClass('booking-' + id);
//     shouldShowBooking = true;
//   } else if (page === '/' || page === '/gitek' || page === '/home' || page === '/hotel') {
//     id = 'room';
//     document.querySelector('.booking').classList.add('booking');
//     document.querySelector('.booking').classList.add('booking-' + id);
//     shouldShowBooking = true;
//   } else {
//     closeBooking();
//     shouldShowBooking = false;
//   }
// }



// function handleAnchor(event) {

//   console.log('scroll position ran');

//   let hash;
//   if (event) {
//     hash = $(this).attr('href');
//   } else {
//     hash = window.location.hash
//   }

//   if (hash == '#enquire') {
//     triggerEnquiryPopup();
//     console.log('this is enquire button');
//   }

//   else if (hash == '#book') {

//     openBooking();
//     // switchBookTab
//     setBookingTab();

//   } else if (hash == '#bookroom') {

//     openBooking();
//     // $('.booking').removeClass().addClass('booking').addClass('booking-room');

//   } else if (hash == '#booktable') {

//     openBooking();
//     // $('.booking').removeClass().addClass('booking').addClass('booking-table');

//   } else if (hash) {

//     // l('scroll to anchor');
//     if ($(hash).length) {
//       // const target = $(hash).offset().top;
//       // const offset = $('.header').outerHeight();
//       // l(target);

//       // $("html, body").animate({ scrollTop: target - offset }, 0);
//     }
//     else {
//       alert('no container with that anchor exists');
//     }

//     // } else if (sessionStorage.getItem("scrollPosition") !== null) {


//     // document.body.classList.add('scrolled');
//     // $("html, body").animate({ scrollTop: sessionStorage.getItem("scrollPosition") }, 0);
//     // sessionStorage.removeItem("scrollPosition");

//   } else {
//     // l('scroll to top');
//     // $("html, body").animate({ scrollTop: 0 }, 500);
//     // console.log('this ran');

//   }

// }



// function loadSwipers() {
//   var sliders = [];

//   var imageSliders = document.querySelectorAll('.images_slider');
//   for (var index = 0; index < imageSliders.length; index++) {
//     var element = imageSliders[index];
//     element.classList.add('s' + index);

//     var slider = new Swiper('.s' + index, {
//       loop: true,
//       slidesPerView: 3.5,
//       spaceBetween: 0,
//       freeMode: true,
//       breakpoints: {
//         320: {
//           slidesPerView: 1.5,
//         },
//         640: {
//           slidesPerView: 3.5,
//         },
//         1500: {
//           slidesPerView: 4.5
//         }
//       },
//       autoplay: {
//         delay: 2500,
//         disableOnInteraction: false,
//       },
//     });

//     sliders.push(slider);
//   }
// }


// function highlightActive() {
//   clearNav();

//   var matchingLinks = document.querySelectorAll('.nav a[href*="' + window.location.pathname + '"]');
//   for (var j = 0; j < matchingLinks.length; j++) {
//     matchingLinks[j].classList.add('active');
//   }

//   if (window.location.pathname === '/') {
//     clearNav();
//   }
// }

// function clearNav() {
//   var activeLinks = document.querySelectorAll('.nav a.active');
//   for (var i = 0; i < activeLinks.length; i++) {
//     activeLinks[i].classList.remove('active');
//   }
// }

// function setCookie() {
//   l('set cookie');
//   document.cookie = 'cookie-note=1;max-age=864000';
//   $('.cookie').addClass('hidden');
// }

// function checkCookie() {
//   l('check cookie');
//   if (document.cookie.indexOf('cookie-note=1') !== -1) {
//     $('.cookie').addClass('hidden');
//   } else {
//     $('.cookie').removeClass('hidden');
//   }

//   if (document.cookie.indexOf('cookie-form=1') !== -1) {
//     $('.overlay').addClass('hidden');
//   } else {
//     $('.overlay').removeClass('hidden');
//   }

// }

function lazyImages() {

  l('lazyImages');
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.add("animate");
          lazyImageObserver.unobserve(lazyImage);
          // throttle(loadIsotope, 200);
        }
      });
    });

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  }
}



// function setHeaderBackgroundColor() {
//   let banner = document.getElementById("banner"),
//     header = document.getElementById("header"),
//     headerBg = document.querySelector(".header-bg"),
//     subnav = document.querySelector(".subnav"),
//     bannerColor = banner ? banner.getAttribute("data-banner-color") : null;

//   if (bannerColor) {
//     if (header) header.style.backgroundColor = bannerColor;  // Set the background colour for header
//     if (headerBg) headerBg.style.backgroundColor = bannerColor; // Set the background colour for .header-bg
//     if (banner) banner.style.backgroundColor = bannerColor;  // Set the background colour for banner
//     if (subnav) subnav.style.backgroundColor = bannerColor;  // Set the background colour for subnav
//   }
//   console.log(bannerColor);
// }

// function addSlugClassToBody() {
//   const pathname = window.location.pathname;
//   let slug = pathname.split("/").filter(Boolean).pop() || 'home';
//   const preservedClasses = ['admin', 'noadmin', 'scrolled', 'page'];
//   const currentClasses = [...document.body.classList];

//   if (!currentClasses.includes(slug)) {
//     for (let cls of currentClasses) {
//       if (!preservedClasses.includes(cls) && cls !== slug) {
//         document.body.classList.remove(cls);
//       }
//     }
//     document.body.classList.add(slug);
//   }
// }

// function toggleEventFields() {
//   const formEventFields = document.querySelector('.form__event-fields');
//   const pathname = window.location.pathname;

//   // Check if you're on the events page
//   if (pathname.includes('/events')) {
//     if (formEventFields) formEventFields.classList.add('form__event-fields--visible');
//   } else {
//     if (formEventFields) formEventFields.classList.remove('form__event-fields--visible');
//   }
// }


// function triggerEnquiryPopup() {
//   console.log('triggerEnquiryPopup called');
//   sessionStorage.removeItem('popupClosed');
//   showPopup();
// }


// function showPopup() {
//   console.log('showPopup called');

//   const formPopup = document.getElementById('form-popup');
//   const popupWrapper = document.getElementById('popup-wrapper');



//   formPopup.classList.add('form-popup--visible');
//   popupWrapper.classList.add('popup-wrapper--visible');
//   toggleEventFields();

//   if (window.location.pathname !== '/events') {
//     const eventFieldsElement = document.getElementById("event-fields");
//     if (window.location.pathname !== '/events') {
//       eventFieldsElement.classList.add('hide');
//     } else {
//       eventFieldsElement.classList.remove('hide');
//     }
//   }


// }



// // function hidePopup() {
// //   const formPopup = document.getElementById('form-popup');
// //   const popupWrapper = document.getElementById('popup-wrapper');
// //   formPopup.classList.remove('form-popup--visible');
// //   popupWrapper.classList.remove('popup-wrapper--visible');
// //   sessionStorage.setItem('popupClosed', 'true');
// //   console.log('Popup closed');
// // }


// Event listener for the close button
// if (document.querySelector('.popup_close')) {
//   document.querySelector('.popup_close').addEventListener('click', function () {
//     console.log('clicked close');
//     hidePopup();
//   });
// }


// Event listener for clicking outside the form, on the wrapper
// if (document.querySelector('.popup-wrapper')) {
//   document.querySelector('.popup-wrapper').addEventListener('click', function (event) {
//     console.log('clicked wrapper');
//     if (event.target === this) {
//       hidePopup();
//     }
//   });
// }

// Event listener for the close button
// if (document.querySelector('.popup_close')) {
//   document.querySelector('.popup_close').addEventListener('click', function () {
//     hidePopup();
//   });
// }


// window.addEventListener('scroll', function () {
//   const formPopup = document.getElementById('form-popup'),
//     showPopupAt = parseFloat(formPopup.getAttribute('data-showPopup')),
//     popupWrapper = document.getElementById('popup-wrapper'),
//     bookingElement = document.querySelector('.booking'),
//     windowHeight = window.innerHeight,
//     fullHeight = document.body.scrollHeight,
//     scrolled = window.scrollY,
//     triggerPoint = fullHeight * showPopupAt,
//     selectedPageSlugs = popupWrapper.getAttribute('data-selected-slugs').split(','),
//     eventFieldsElement = document.getElementById("event-fields");


//   // For Popup: Calculate 50% of the page height
//   const halfwayPoint = fullHeight * 0.5;

//   // For Booking: Calculate 30% of the page height
//   const thirtyPercentPoint = fullHeight * 0.3;


//   let currentPath = window.location.pathname;
//   let currentSlug = currentPath.split('/').pop();

//   if (currentPath === '/') {
//     currentSlug = 'home';
//   }

//   if (window.location.pathname !== '/events') {
//     eventFieldsElement.classList.add('hide');
//   } else {
//     eventFieldsElement.classList.remove('hide');
//   }

//   if (selectedPageSlugs.includes(currentSlug)) {



//     if (scrolled + windowHeight >= triggerPoint) {
//       // console.log('true');
//       if (sessionStorage.getItem('popupClosed') !== 'true') {
//         formPopup.classList.add('form-popup--visible');
//         popupWrapper.classList.add('popup-wrapper--visible');
//       }
//     }
//   }



//   // Hide booking form when 30% down the page, show when back at top
//   if (shouldShowBooking) {
//     if (scrolled + windowHeight >= thirtyPercentPoint) {
//       bookingElement.classList.add('close');
//     } else {
//       bookingElement.classList.remove('close');
//     }
//   }

//   // Show booking tab when scrolled to the top
//   if (scrolled === 0) {
//     if (currentSlug !== 'events') {
//       bookingElement.classList.remove('close');
//     }
//     formPopup.classList.remove('form-popup--visible');
//     popupWrapper.classList.remove('popup-wrapper--visible');
//   }

// });


// document.addEventListener("DOMContentLoaded", function () {
//   const form = document.getElementById("popup-form");
//   if (form) {
//     form.addEventListener("submit", function (event) {
//       sessionStorage.setItem('popupClosed', 'true');
//       sessionStorage.setItem('scrollPosition', window.scrollY);
//       sessionStorage.setItem('formSubmitSuccess', 'true');
//     });
//   }

// });

// function hidePopSuccessMessage() {
//   const formSubmitSuccess = sessionStorage.getItem('formSubmitSuccess');
//   const popupSuccess = document.querySelector(".popup-success");
//   if (formSubmitSuccess === 'true') {
//     console.log('form success is set');
//     setTimeout(function () {
//       console.log('time out ran');

//       popupSuccess.classList.add('hide');

//     }, 5000);
//   }
// }

// function initMap() {

//   if (document.querySelector('.map')) {

//     l('map exists – run');

//   } else {
//     l('map doesnt exists – dont run');
//   }
// }